console.log("Custom JS loaded");
document.addEventListener('DOMContentLoaded', function(){
    var wishlistWrapper = document.querySelector('.product-checklist-status');
    var wishlistError = document.querySelector('.error-wishlist');
    var wishlistButton = document.getElementById('wishlist-button');
    var needitButton = document.getElementById('needit-button');
    var haveitButton = document.getElementById('haveit-button');
    var wishlistedWrapper = document.getElementById('wishlistedVariants');
    var variantSelect = document.querySelector('select[name="options[Edition Type]"]');
    var variantSelectRewards = document.querySelector('select[name="options[Variant]"]');
    
    var wishlistedJSON, sku, action, tofilter, typeList;

    if(typeof wishlistedWrapper !== 'undefined' && wishlistedWrapper !== null) {
        wishlistedJSON = JSON.parse(wishlistedWrapper.innerText);
        console.log(wishlistedJSON);
    }

    if(typeof needitButton !== "undefined" && needitButton != null) {
        if(needitButton.dataset.type == 'vinegar') {
            typeList = 'vinegar';
        } else {
            typeList = 'partner';
        }
        needitButton.addEventListener("click", function(e){
            e.preventDefault();

            if(haveitButton.classList.contains('checked')) {
                return false;
            }   
            sku = needitButton.dataset.sku;
            wishlistWrapper.classList.add('processing');
            wishlistError.innerText = '';
            if(needitButton.classList.contains('checked')) {
                action = 'unchecked';
            } else {
                action = 'checked';
            }
            axios({
                method: 'post',
                url: 'https://app.vinegarsyndrome.com/wishlist',
                data: 'owner_id=' + this.dataset.customerId + '&sku=' +  this.dataset.sku + '&action=' + action + '&checklist=need' + '&typeList=' + typeList
            })
            .then(function (response) {
                if(action == 'checked') {
                    needitButton.classList.add('checked');
                    wishlistedJSON.wishlisted.push(needitButton.dataset.sku);
                    wishlistedWrapper.innerText = JSON.stringify(wishlistedJSON);
                } else {
                    needitButton.classList.remove('checked');
                    tofilter = wishlistedJSON.wishlisted.filter(function(wsku) {
                        return wsku != needitButton.dataset.sku;
                    });

                    wishlistedJSON.wishlisted = tofilter;
                    wishlistedWrapper.innerText = JSON.stringify(wishlistedJSON);
                }
                wishlistWrapper.classList.remove('processing');
            }).catch(function (error) {
                console.log(error);
                wishlistWrapper.classList.remove('processing');
                wishlistError.innerText = 'There was an error, please try again!';
            });
        });
    }

    if(typeof haveitButton !== "undefined" && haveitButton != null) {
        if(haveitButton.dataset.type == 'vinegar') {
            typeList = 'vinegar';
        } else {
            typeList = 'partner';
        }

        haveitButton.addEventListener("click", function(e){
            e.preventDefault();

            if(needitButton.classList.contains('checked')) {
                needitButton.classList.remove('checked');
            }   
            sku = haveitButton.dataset.sku;
            wishlistWrapper.classList.add('processing');
            wishlistError.innerText = '';
            if(haveitButton.classList.contains('checked')) {
                action = 'unchecked';
            } else {
                action = 'checked';
            }
            axios({
                method: 'post',
                url: 'https://app.vinegarsyndrome.com/wishlist',
                data: 'owner_id=' + this.dataset.customerId + '&sku=' +  this.dataset.sku + '&action=' + action + '&checklist=have' + '&typeList=' + typeList
            })
            .then(function (response) {
                if(action == 'checked') {
                    haveitButton.classList.add('checked');
                    wishlistedJSON.have.push(haveitButton.dataset.sku);
                    wishlistedWrapper.innerText = JSON.stringify(wishlistedJSON);
                } else {
                    haveitButton.classList.remove('checked');
                    tofilter = wishlistedJSON.have.filter(function(wsku) {
                        return wsku != haveitButton.dataset.sku;
                    });

                    wishlistedJSON.have = tofilter;
                    wishlistedWrapper.innerText = JSON.stringify(wishlistedJSON);
                }
                wishlistWrapper.classList.remove('processing');
            }).catch(function (error) {
                console.log(error);
                wishlistWrapper.classList.remove('processing');
                wishlistError.innerText = 'There was an error, please try again!';
            });
        });
    }

    if(typeof variantSelect !== "undefined" && variantSelect != null && typeof needitButton !== "undefined" && needitButton != null) {
        variantSelect.addEventListener('change', function(e){
            sku = document.querySelector('#variantSku').innerText;
            needitButton.dataset.sku = sku;
            haveitButton.dataset.sku = sku;

            if(wishlistedJSON.wishlisted.length !== 0) {
                for (var index = 0; index < wishlistedJSON.wishlisted.length; index++) {
                    var w = wishlistedJSON.wishlisted[index];
                    if(w == sku) {
                        needitButton.classList.add('checked');
                        console.log(w + sku);
                        break;
                    } else if(needitButton.classList.contains('checked')) {
                        needitButton.classList.remove('checked');
                    }
                }
            }

            if(wishlistedJSON.have.length !== 0) {
                for (var index = 0; index < wishlistedJSON.have.length; index++) {
                    var w = wishlistedJSON.have[index];
                    if(w == sku) {
                        haveitButton.classList.add('checked');
                        console.log(w + sku);
                        break;
                    } else if(haveitButton.classList.contains('checked')) {
                        haveitButton.classList.remove('checked');
                    }
                }
            }
        });
    }

    if(variantSelectRewards !== 'undefined' && variantSelectRewards != null) {
        var selectId = document.querySelector('select[name="id"]');

        variantSelectRewards.addEventListener('change', function(e){
            var variantId = document.querySelector('.formVariantId').value;
            //Check for reward
            var button_redeem = document.querySelector('.swell-buy-product-btn');

            if(typeof button_redeem != 'undefined' && button_redeem != null) {
                button_redeem.dataset.variantId = variantId;
                selectId.value = variantId;
            }
        });
    }
});